<template lang="pug">
.row.d-flex.flex-md-row-reverse.align-items-center.i_mb_5.i_mt_sm_4.map-item
  .col-md-8.col-lg-8.i_pr_0
    .info.i_pl_5.i_pl_md_3.i_pt_2.i_pl_sm_0
      .title.d-flex.justify-content-between.aiign-items-cemter
        h5 {{ LocationName }}
        .map_title_btn(@click="isExpand = !isExpand")
        .map_title_cover.d-none.d-md-block
      ul
        li.i_mt_2
          svg-icon(iconClass="ic_place", className="icon")
          span.i_ml_1 {{ LocationAddr }}
        li.i_mt_2
          svg-icon(iconClass="ic_phone", className="icon")
          span.i_ml_1 {{ LocationTel }}
        li.i_mt_2
          svg-icon(iconClass="ic_fax", className="icon")
          span.i_ml_1 {{ LocationFax }}
  .col-md-4.d-flex.justify-content-center.justify-content-lg-end.col-lg-4.i_plr_0.i_pr_2.i_pr_md_0.i_mt_sm_0
    img.map(
      :src="LocationImage",
    )
</template>

<script>
export default {
  name: "Map",
  props: {
    LocationName: String,
    LocationAddr: String,
    LocationTel: String,
    LocationFax: String,
    LocationImage: String,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/location";
</style>
